import type { IconData } from '@stacksjs/iconify-core'

export const dog1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 5c9.031 0 17 12.259 17 27.595C41 35.31 41 43 24 43S7 35.31 7 32.595C7 17.26 14.969 5 24 5\"/><path d=\"M17.65 7.075C8.62 7.901 3 15.34 3 21c0 2.173.776 5.395 4.242 7.006m33.517 0C44.224 26.395 45 23.173 45 21c0-5.66-5.62-13.1-14.65-13.925M24 33v3m6-16v1m-12-1v1m-2 15s1 2 4 2s4-2 4-2m0 0s1 2 4 2s4-2 4-2m-8-3c-2.125 0-4-1.613-4-3.631C20 29.012 20 28 24 28s4 1.012 4 1.369C28 31.387 26.125 33 24 33\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default dog1
